















































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Branch } from "@/data/models/Branch";
import { hasClientEnabledStrictBranchFilters, observeClient } from "@/data/repository/ClientRepository";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { formatLocationInfo, joinToString } from "@/utils/LocalisationHelper";
import { Component, Vue, Ref } from "vue-property-decorator";
import BranchFormComponent from "./BranchForm.vue";
import ClientPanel from "@/data/models/ClientPanel";
import { getAvailablePanels } from "@/data/repository/ClientPanelRepository";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
@Component({
  components: {
    "branch-form": BranchFormComponent,
  },
})
export default class BranchList extends Vue {
  /** Nothing may be changed while "Sicht auf" is active (ticket 2610051). */
  get isViewAsReadOnly() {
    return isViewAsSelected();
  }

  subscriptions: Array<() => void> = [];
  branches: Branch[] = [];

  clientPanels: Array<ClientPanel> = [];

  @Ref("branchForm")
  branchForm!: BranchFormComponent;

  /** Table header background, theme-aware so it stays readable in dark mode. */
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get disableBranchDeletion() {
    const strictBranchFilters = hasClientEnabledStrictBranchFilters();

    return this.branches.length < 2 && strictBranchFilters;
  }

  getBranchName(branch: Branch) {
    return joinToString([branch.name, branch.branchNumber.toString()], " - ");
  }

  getBranchLocationDescription(branch: Branch) {
    return formatLocationInfo(branch);
  }

  mounted() {
    this.setToolbarTitle();

    this.subscriptions.push(
      observeClient((client) => {
        const branches = [];

        if (client.branches) {
          const keys = Object.keys(client.branches);

          for (const key of keys) {
            branches.push(client.branches[key] as Branch);
          }
        }

        this.branches = branches.filter(branch => !branch.deleted)
          .sort(
            (a, b) =>
              (a.branchSortValue ?? a.branchNumber) -
              (b.branchSortValue ?? b.branchNumber)
          );
      })
    );
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription();
    });
  }

  async onCreateBranch() {
    await this.branchForm.show();
  }

  async onEditBranch(branch: Branch) {
    await this.branchForm.show(branch);
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.branches.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }

  async created() {
    this.clientPanels = await getAvailablePanels();
  }
}
